import { alpha } from '@mui/material'
import theme from '../../../../../ui/theme/base'

const styles = {
  section: {
    padding: theme.spacing(4, 0),
  },
  title: {
    mb: 4,
  },
  wrapper: {
    '& .MuiTabs-flexContainer': {
      mt: 2,
    },
    '& .MuiTab-root': {
      flex: '1',
    },
    '& .MuiTabPanel-root': {
      padding: 0,
      [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(0),
      },
    },
  },
  fieldsWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    rowGap: theme.spacing(1),
    columnGap: theme.spacing(2),
  },
  searchField: {
    width: '100%',
  },
  searchErrorAlert: {
    mt: 1,
  },
  warningAlert: {
    mt: 2,
  },
  pickupPointAlert: {
    mt: 2,
  },
  confirmButton: {
    mt: 2,
  },
  changePickupPoint: {
    mt: 2,
  },
  pickupPointSelectedWrapper: {
    maxWidth: 470,
    '& .MuiListItem-root': {
      alignItems: 'flex-start',
    },
    '& .MuiListItemText-secondary.MuiTypography-root': {
      ...theme.typography.label,
    },
  },
  scrolledContainer: {
    overflowY: 'auto',
    height: 144,
    borderTop: '1px dashed #cccccc',
  },
  scrolledWrapper: {
    position: 'relative',
    overflowY: 'auto',
    width: '100%',
    height: '100%',
    '&::before, &::after': {
      content: '""',
      display: 'block',
      position: 'sticky',
      left: 0,
      width: '100%',
      zIndex: '99',
    },
    '&::before': {
      top: 0,
      boxShadow: '0 0 20px var(--top-mask-size, 0) #f9f9f9;',
    },
    '&::after': {
      bottom: 0,
      boxShadow: '0 0 20px var(--bottom-mask-size, 25px) #f9f9f9;',
    },
  },
  scrolledTop: {
    '--top-mask-size': '25px',
  },
  scrolledBottom: {
    '--bottom-mask-size': '0',
  },
  completeInfoItemNested: {
    '& .MuiListItem-root': {
      pl: 6,
    },
    '& .MuiListItemText-primary.MuiTypography-root': {
      ...theme.typography.body2,
      color: theme.palette.neutral.main,
    },
    '& .MuiListItemText-secondary.MuiTypography-root': {
      ...theme.typography.h4,
      color: theme.palette.neutral.dark,
      '& .MuiTypography-h4': {
        p: 0,
      },
    },
  },
  schedule: {
    '& .MuiListItemText-root .MuiTypography-root': {
      padding: theme.spacing(0),
    },
  },

  fieldPrefixPhone: {
    marginTop: theme.spacing(1.5),
    flex: '1 0 auto',
    display: 'flex',
    alignItems: 'flex-start',
    '& .MuiInput-root': {
      marginTop: theme.spacing(0),
    },
  },

  fieldPrefixPhoneSelect: {
      minWidth: '80px !important',
      width: '80px !important',
    '&::before': {
      content: '""',
      position: 'absolute',
      right: theme.spacing(0),
      top: '50%',
      transform: 'translateY(-50%)',
      width: '1px',
      height: '60%',
      backgroundColor: alpha(theme.palette.neutral.lighter, 0.4),
      zIndex: 1,
    },
    '& .MuiInput-input': {
      borderRight: theme.spacing(0),
    },

    '& .MuiAutocomplete-input:first-of-type': {
      padding: '10px !important'
    },
  },
  fieldPrefixPhoneInput: {
    '& .MuiInput-input': {
      borderLeft: theme.spacing(0),
    },
  },
  fieldMD: {
    flex: '1 0 auto',
    width: 'fit-content',
    '& .MuiAutocomplete-root': {
      minWidth: 468,
      width: '100%',
    },
  },
  loader: {
    backgroundColor:'black', 
    position:'absolute', 
    zIndex:999, 
    width:'100%', 
    height:'100%', 
    top:'-50%', 
    left:'-50%',
    opacity:0.75,
    justifyContent:'center',
    alignItems: 'center',
    display:'flex'
  },
}

export default styles
